module.exports = "/build/web/svg/social/default/tiktok.13aaa09946e5ce985c7aa5abd4e7ccbd.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/tiktok.svg
// module id = 186
// module chunks = 24